import mapboxgl from 'mapbox-gl'
import * as React from 'react'
import { GeoCoords } from 'src/types/schema/graphql'
import { mapStyle } from '../../../../util/constants'

interface IMap {
    geo: GeoCoords
}

const accessToken = process.env.NEXT_PUBLIC_MAPBOX_TOKEN

const Map: React.FC<IMap> = ({ geo }) => {
    const mapContainer = React.useRef(null)
    const [map, setMap] = React.useState<mapboxgl.Map | null>(null)
    const { lon, lat } = geo
    React.useEffect(() => {
        if (mapContainer?.current && !map) {
            const map = new mapboxgl.Map({
                container: mapContainer.current,
                style: mapStyle,
                zoom: 14,
                accessToken,
                interactive: false,
                center: [lon, lat],
            })
            setMap(map)

            const markerEl = document.createElement('div')
            markerEl.className = 'marker flex items-center justify-center'
            markerEl.style.backgroundImage = `url('../../../assets/Marker-Green-Icon.png')`
            markerEl.style.width = '63px'
            markerEl.style.height = '70px'
            markerEl.style.backgroundSize = '100%'
            new mapboxgl.Marker(markerEl).setLngLat([lon, lat]).addTo(map)
        }

        return () => {
            map?.remove()
        }
    }, [mapContainer.current])

    return <div ref={mapContainer} className='w-82 relative h-48 overflow-hidden rounded-lg' />
}

export default Map
